import '@/services/composition-api';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
// sweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
// Registro de componentes internos
import ComponentRegistration from '@/utils/component-registration';
// Componente de moeda
import money from 'v-money';
// Analytics
import VueGtag from 'vue-gtag';
import VueCookies from 'vue-cookies';
import VueMeta from 'vue-meta';
import Hotjar from 'vue-hotjar';
// facebook pixel
import VueFacebookPixel from 'vue-facebook-pixel';

Vue.use(VueFacebookPixel);

Vue.analytics.fbq.init(process.env.VUE_APP_FACEBOOK_PIXEL, {});

Vue.analytics.fbq.event('ViewContent', {
    track: 'PageView',
});

// Registro de Cookies
Vue.use(VueCookies);

if (process.env.VUE_APP_ENV != 'local') {
    Vue.use(Hotjar, {
        id: process.env.VUE_APP_HOTJAR_KEY,
    });
}
const optionsSweetalert = {
    customClass: {
        confirmButton: 'eg-button-sweetalert eg-button-blue',
    },
    reverseButtons: true,
    buttonsStyling: false,
};

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});

Vue.use(VueSweetalert2, optionsSweetalert);
// register directive v-money and component <money>
Vue.use(money, { precision: 4 });
// GTAG
Vue.use(
    VueGtag,
    {
        config: {
            id: process.env.VUE_APP_ANALYTICS_ID,
            params: {
                // eslint-disable-next-line camelcase
                optimize_id: process.env.VUE_APP_OPTIMIZE_ID,
            },
        },
        includes: [{ id: process.env.VUE_APP_TAG_MANAGER_ID }],
    },
    router
);

Vue.config.productionTip = false;

// css global
import '@/scss/core.scss';

// Registros de Componentes
ComponentRegistration();
new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
